import type { Vehicle } from '@bambi/api-client/schemas';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
export interface IFleetState {
  vehicles: any[];
  vehicleSearchTerm: string;
  selectedVehicle: Vehicle;
  vehicleCredentialsSearchTerm: string;
  vehicleTagModal: {
    vehicleId: string;
    isOpen: boolean;
  };
  vehicleTags: string[];
}

export const initialState: IFleetState = {
  vehicles: [],
  vehicleSearchTerm: '',
  selectedVehicle: {
    id: '',
    nickname: '',
    vin: '',
    organization_id: '',
    created_at: '',
    updated_at: '',
    make: '',
    model: '',
    color: '',
    year: null,
    can_be_scheduled: true,
    license_plate: '',
    category: 'ambulatory',
    notes: '',
    storage_location: {
      label: '',
      place_id: '',
      latitude: 0,
      longitude: 0,
    },
    capacity_configurations: [],
    tags: [],
  },
  vehicleCredentialsSearchTerm: '',
  vehicleTagModal: {
    vehicleId: '',
    isOpen: false,
  },
  vehicleTags: [],
};

export const fleetSlice = createSlice({
  name: 'fleet',
  initialState,
  reducers: {
    setVehicles: (state, action) => {
      state.vehicles = action.payload;
    },
    setSelectedVehicle: (state, action) => {
      const newSelectedVehicle = {
        ...state.selectedVehicle,
        ...action.payload,
      };
      state.selectedVehicle = newSelectedVehicle;
    },
    clearSelectedVehicle: (state) => {
      state.selectedVehicle = initialState.selectedVehicle;
    },
    setVehicleSearchTerm: (state, action) => {
      state.vehicleSearchTerm = action.payload;
    },
    setVehicleCredentialsSearchTerm: (state, action) => {
      state.vehicleCredentialsSearchTerm = action.payload;
    },
    onAddVehicleTags: (state, action: PayloadAction<string>) => {
      state.vehicleTagModal = {
        isOpen: true,
        vehicleId: action.payload,
      };
    },
    onCloseVehicleTags: (state) => {
      state.vehicleTagModal = { ...initialState.vehicleTagModal };
    },
    onVehicleTagApply: (state, action: PayloadAction<string[]>) => {
      state.vehicleTags = action.payload;
    },
  },
});

export const {
  setVehicles,
  setSelectedVehicle,
  clearSelectedVehicle,
  setVehicleSearchTerm,
  setVehicleCredentialsSearchTerm,
} = fleetSlice.actions;
